module.exports = __webpack_public_path__ + "media/thud.8464ff46.ogg";